export default "__VITE_ASSET__BGBtcjPF__"